import styled from 'styled-components';

export const Frame = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  width: 100%;
  max-width: 40rem;
  padding: ${({ theme }) => theme.spacing.lg};
  background-color: ${({ theme }) => theme.colors.white};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 2rem;
`;

export const FrameBar = styled.div`
  display: flex;
  align-items: center;
`;

export const FrameLogo = styled.span`
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.04em;
  color: ${({ theme }) => theme.colors.accent};
`;

export const SearchPill = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.6rem;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkSlate};
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: 999rem;
`;

export const SearchIcon = styled.span`
  font-size: 1.4rem;
  opacity: 0.6;
`;

export const ResultRow = styled.div<{ $you?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: 1.2rem 1.4rem;
  background-color: ${({ theme, $you }) =>
    $you ? theme.colors.accentBgSoft : theme.colors.surfaceSoft};
  border: 0.1rem solid
    ${({ theme, $you }) => ($you ? theme.colors.accent : theme.colors.border)};
  border-radius: 1.4rem;
`;

export const ResultAvatar = styled.span<{ $you?: boolean }>`
  display: flex;
  flex-shrink: 0;
  width: 3.6rem;
  height: 3.6rem;
  overflow: hidden;
  border: 0.2rem solid
    ${({ theme, $you }) => ($you ? theme.colors.accent : theme.colors.border)};
  border-radius: 50%;
`;

export const ResultPhoto = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ResultText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  flex: 1;
`;

export const ResultName = styled.span`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const YouBadge = styled.span`
  padding: 0.2rem 0.8rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.overlayText};
  background-color: ${({ theme }) => theme.colors.accent};
  border-radius: 999rem;
`;

export const ResultTrade = styled.span`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const ResultRating = styled.span`
  flex-shrink: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.amber};
`;
